import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { formatPrice, formatPriceDot, formatPricewithdecimal } from "../../NumberFormat";
import TableCount from "./FourD/FourDThreeDTwoD/TableCount";
import { useDispatch, useSelector } from "react-redux";
import InfoIcon from "../../../assets/images/Icons/info_icon.svg";
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../helpers/global_helper";
import InformasiPopup from "../MobileDesign/FourDMo/Versi_WAPP_mo/InformasiPopup";
import { set4dGameSubChildtype } from "../../../redux/actions";
const CommonBetHeader = (props) => {
  const dispatch = useDispatch()
  const device = useSelector((state) => state.CommonConfig.device_type);
  const discountPrize = useSelector((state) => state.CommonConfig.discount);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const game_sub_type = useSelector((state) => state.GameSubType.game_sub_type);
  const game_sub_child_type = useSelector(
    (state) => state.GameSubType.game_sub_child_type
  );
  const [reqData, setReqData] = useState({
    gameId: gameId,
    type: game_sub_child_type,
  });
  const [respData, setRespData] = useState([]);

  const [isInfoResultPopup, setIsInfoResultPopup] = useState(false);
  const [isInfoPopup, setIsInfoPopup] = useState(false);
  const [multipleAmt, setMultipleAmt] = useState('1.000');
  const [minAmt, setMinAmt] = useState('');
  const validPaths = [
    "/game/Fifty_Fifty",
    "/game/Fifty_Fifty_2D",
    "/game/Tengah_Dasar",
    "/game/Silang_Kembang",
  ];
  useEffect(() => {
    if(game_sub_type !== "4D3D2D" && game_sub_type !== "4d3d2d" && game_sub_type !== "3DDEPAN" && game_sub_type !== "TwoDDepan"  && game_sub_type !== "TwoDTengah") {
      dispatch(set4dGameSubChildtype({key : "game_sub_child_type", value : "DISCOUNT"}))
    }
  }, [game_sub_type])
  
  useEffect(() => {
    setReqData({
      ...reqData,
      type : game_sub_child_type
    })
  }, [game_sub_child_type, game_sub_type])

  const openInformasiPopup = () => {
    makeAjax(url.TOGEL_API.getAllPrizeDiscount, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code == "market_close_err") {
          showMessage(props.t("referresh_page"), "error", "error");
          return;
        }
      }
      setIsInfoPopup(true);
      setRespData(response.data);
    });
  };
  const closeInformasiPopup = () => {
    setIsInfoPopup(false);
  };

  useEffect(() => {
    let amt = '';
    let minVal = '';
    switch (game_sub_type) {
      case '4D3D2D':
      case '4d3d2d':
      case '3DDEPAN':
      case 'TwoDDepan':
      case 'TwoDTengah':
        if (game_sub_child_type === 'DISCOUNT') {
          amt = discountPrize.showMultiple;
          if (game_sub_type == '4D3D2D' || game_sub_type == '4d3d2d') {
            minVal = discountPrize.showMin4d;
          } else if (game_sub_type == '3DDEPAN') {
            minVal = discountPrize.showMin3dDepan;
          } else if (game_sub_type == 'TwoDDepan') {
            minVal = discountPrize.showMin2dDepan;
          } else if (game_sub_type == 'TwoDTengah') {
            minVal = discountPrize.showMin2dTengah;
          }
        } else if (game_sub_child_type === 'FULLBET') {
          amt = discountPrize.showMultipleFullbet;
          if (game_sub_type == '4D3D2D' || game_sub_type == '4d3d2d') {
            minVal = discountPrize.showMin4dFullbet;
          } else if (game_sub_type == '3DDEPAN') {
            minVal = discountPrize.showMin3dDepanFullbet;
          } else if (game_sub_type == 'TwoDDepan') {
            minVal = discountPrize.showMin2dDepanFullbet;
          } else if (game_sub_type == 'TwoDTengah') {
            minVal = discountPrize.showMin2dTengahFullbet;
          }
        } else if (game_sub_child_type === 'PRIZE123') {
          amt = discountPrize.showMultiplePrize123;
          if (game_sub_type == '4D3D2D' || game_sub_type == '4d3d2d') {
            minVal = discountPrize.showMin4dPrize123;
          } else if (game_sub_type == '3DDEPAN') {
            minVal = discountPrize.showMin3dDepanPrize123;
          } else if (game_sub_type == 'TwoDDepan') {
            minVal = discountPrize.showMin2dDepanPrize123;
          } else if (game_sub_type == 'TwoDTengah') {
            minVal = discountPrize.showMin2dTengahPrize123;
          }
        } else {
          amt = discountPrize.showMultiple;
          if (game_sub_type == '4D3D2D' || game_sub_type == '4d3d2d') {
            minVal = discountPrize.showMin4d;
          } else if (game_sub_type == '3DDEPAN') {
            minVal = discountPrize.showMin3dDepan;
          } else if (game_sub_type == 'TwoDDepan') {
            minVal = discountPrize.showMin2dDepan;
          } else if (game_sub_type == 'TwoDTengah') {
            minVal = discountPrize.showMin2dTengah;
          }
        }
        break;
      // case 'quick4d':
      // case 'bbcampuran':
      //   amt = discountPrize.showMultipleNomor;
      //   break;
      case 'colokbebas':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case 'colokbebas2d':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case 'coloknaga':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case 'colokjitu':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case 'tengahtepi':
      case 'DASAR':
      case 'TENGAH':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case '50502d':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case '5050':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case 'shio':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case 'macaushio':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case 'kombinasi':
      case 'kembangkempis':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case 'silanghomo':
        amt = discountPrize.showMultiple;
        minVal = discountPrize.showMin;
        break;
      case '5d6d':
      case '5D6D':
        if (game_sub_child_type === 'DISCOUNT') {
          amt = discountPrize.showMultiple6d;
          minVal = discountPrize.showMin6d;
        } else if (game_sub_child_type === 'FULLBET') {
          amt = discountPrize.showMultiple6dFullbet;
          minVal = discountPrize.showMin6dFullbet;
        } else if (game_sub_child_type === 'PRIZE123') {
          amt = discountPrize.showMultiple6dPrize123;
          minVal = discountPrize.showMin6dPrize123;
        } else {
          amt = discountPrize.showMultiple6d;
          minVal = discountPrize.showMin6d;
        } break;
      default:
        break;
    }
    setMultipleAmt(formatPriceDot(amt));
    setMinAmt(minVal);    
  }, [game_sub_type, discountPrize]);

  return (
    <>
      <table className="commonBetHeader-table" style={{ borderBottom: 0 }}>
        <thead>
          <tr>
            {props.rowsToShow !== null && (
              <th
                style={{
                  whiteSpace: "nowrap",
                  textAlign: "left",
                  paddingLeft: 10,
                }}
              >
                {props.t("line")}
                <TableCount
                  rowsToShow={props.rowsToShow}
                  handleRowsToShowChange={props.handleRowsToShowChange}
                />
              </th>
            )}
            <th
              style={{
                whiteSpace: "nowrap",
                textAlign: "center",
                paddingRight: 5,
                width: device === "Desktop" ? "712px" : "200px",
              }}
            >
              <p style={{ marginLeft: props.gameName === "kombinasi" ? "150px" : "0px" }}>
                {props.betText ? (
                  props.betText
                ) : (
                  <>
                    {(minAmt == 1000) ? (
                      <>
                        {props.t("Nominal Bet 1 =")} {multipleAmt} {props.t("IDR")}
                      </>
                    ) : (
                      <>
                        {props.t("Nominal Bet 0.1 =")} {minAmt} {props.t("IDR")}{" "}
                        <br></br>
                        {props.t("Nominal Bet 1 =")} {multipleAmt} {props.t("IDR")}
                      </>
                    )}
                  </>
                )}
              </p>
              <p className="betheader-discount">
                <img
                  src={InfoIcon}
                  alt=""
                  className="versi_mo_info_icon"
                  onClick={openInformasiPopup}
                />{" "}
                {window.location.pathname === "/" ||
                  window.location.pathname === "/game/Four_D" ||
                  window.location.pathname === "/game/Quick_Buy" ||
                  window.location.pathname === "/game/Bbfs" ||
                  window.location.pathname === "/game/pola_tarung" ||
                  window.location.pathname === "/game/ThreeDDepan" ||
                  window.location.pathname === "/game/TwoDDepan" ||
                  window.location.pathname === "/game/TwoDTengah" ||
                  window.location.pathname === "/game/FiveSix_D" ||
                  window.location.pathname === "/game/bolak_balik" ? (
                  <>
                    {game_sub_child_type == "FULLBET" ? "" : "Discount:"}
                    {game_sub_type === "QUICK_BUY" ? (
                      <>
                        <p>
                          4D:{" "}
                          <span className="righttble_bluetxt">
                            {discountPrize.showDisc4d}%
                          </span>
                        </p>
                        <p>
                          3D:{" "}
                          <span className="righttble_bluetxt">
                            {discountPrize.showDisc3d}%
                          </span>
                        </p>
                        <p>
                          2D:{" "}
                          <span className="righttble_bluetxt">
                            {discountPrize.showDisc2d}%
                          </span>
                        </p>
                        <p>
                          Colok Bebas:{" "}
                          <span className="righttble_bluetxt">
                            {discountPrize.showDiscColokBebas}%
                          </span>
                        </p>
                        <p>
                          Colok Bebas 2D:{" "}
                          <span className="righttble_bluetxt">
                            {discountPrize.showDiscColokBebas2d}%
                          </span>{" "}
                        </p>
                        <p>
                          Colok Naga:{" "}
                          <span className="righttble_bluetxt">
                            {discountPrize.showDiscColokNaga}%
                          </span>{" "}
                        </p>

                        <p>
                          Colok Jitu:{" "}
                          <span className="righttble_bluetxt">
                            {discountPrize.showDiscColokJitu}%
                          </span>
                        </p>
                        <p>
                          Tengah/Tepi:{" "}
                          <span className="righttble_bluetxt">
                            {discountPrize.showDiscTengahTepi}%
                          </span>{" "}
                        </p>
                        <p>
                          5050:{" "}
                          <span className="righttble_bluetxt">
                            {discountPrize.showDisc5050}%
                          </span>
                        </p>
                        <p>
                          5050 2D:{" "}
                          <span className="righttble_bluetxt">
                            {" "}
                            {discountPrize.showDiscKombinasi}%
                          </span>
                        </p>
                        <p>
                          Shio:{" "}
                          <span className="righttble_bluetxt">
                            {" "}
                            {discountPrize.showDiscShio}%
                          </span>
                        </p>
                        <p>
                          Silang Homo:{" "}
                          <span className="righttble_bluetxt">
                            {" "}
                            {discountPrize.showDiscSilangHomo}%
                          </span>
                        </p>
                      </>
                    ) : (
                      <>
                        {game_sub_type === "4d3d2d" ||
                          game_sub_type === "4D3D2D" ||
                          game_sub_type == "bbcampuran" ||
                          game_sub_type == "TwoDDepan" ||
                          game_sub_type == "TwoDTengah" ||
                          game_sub_type == "3DDEPAN" ||
                          game_sub_type == "polatarung" ||
                          game_sub_type == "5d6d" ||
                          game_sub_type == "5D6D" ||
                          game_sub_type == "bolak_balik" ? (
                          game_sub_child_type == "DISCOUNT" ? (
                            ((game_sub_type === "4d3d2d" || game_sub_type === "4D3D2D") ? (
                              <p>
                                4D:{discountPrize.showDisc4d}%,3D:
                                {discountPrize.showDisc3d}%,2D:
                                {discountPrize.showDisc2d}%
                              </p>
                            ) : (game_sub_type == "3DDEPAN" ?
                              <p>
                                3D:{discountPrize.showDisc3d}%
                              </p>
                              : game_sub_type == "TwoDDepan" || game_sub_type == "TwoDTengah" ?
                                <p>
                                  2D:{discountPrize.showDisc2d}%
                                </p>
                                :
                                game_sub_type == "5d6d" || game_sub_type == "5D6D" ?
                                  <p>
                                    6D:{discountPrize.showDisc6d}%,
                                    5D:{discountPrize.showDisc5d}%
                                  </p>
                                  :
                                  <p>
                                    4D:{discountPrize.showDisc4d}%,3D:
                                    {discountPrize.showDisc3d}%,2D:
                                    {discountPrize.showDisc2d}%
                                  </p>
                            ))
                          ) : game_sub_child_type == "FULLBET" ? (
                            <p>No Discount</p>
                          ) : game_sub_child_type == "PRIZE" ?
                            (game_sub_type === "5d6d" || game_sub_type === "5D6D") ? (
                              <p>
                                6D:{discountPrize.showDisc6d}%,
                                5D:{discountPrize.showDisc5d}%
                              </p>
                            ) : (
                              <p>
                                4D:
                                {discountPrize.showDisc4dPrize123
                                  ? discountPrize.showDisc4dPrize123
                                  : 0}
                                %,3D:
                                {discountPrize.showDisc3dPrize123
                                  ? discountPrize.showDisc3dPrize123
                                  : 0}
                                %,2D:
                                {discountPrize.showDisc2dPrize123
                                  ? discountPrize.showDisc2dPrize123
                                  : 0}
                                %
                              </p>
                            ) : (
                              <p>
                                4D:{discountPrize.showDisc4d}%,3D:
                                {discountPrize.showDisc3d}%,2D:
                                {discountPrize.showDisc2d}%
                              </p>
                            )
                        ) : game_sub_type === "3DDEPAN" ? (
                          game_sub_child_type == "DISCOUNT" ? (
                            <p>3D:{discountPrize.showDisc3d}%</p>
                          ) : game_sub_child_type == "FULLBET" ? (
                            <p></p>
                          ) : game_sub_child_type == "PRIZE" ? (
                            <p>
                              3D:
                              {discountPrize.showDisc3dPrize123
                                ? discountPrize.showDisc3dPrize123
                                : 0}
                              %
                            </p>
                          ) : (
                            <p>3D:{discountPrize.showDisc3d}%</p>
                          )
                        ) : game_sub_type === "TwoDDepan" ||
                          game_sub_type === "TwoDTengah" ? (
                          game_sub_child_type == "DISCOUNT" ? (
                            <p>2D:{discountPrize.showDisc2d}%</p>
                          ) : game_sub_child_type == "FULLBET" ? (
                            <p></p>
                          ) : game_sub_child_type == "PRIZE" ? (
                            <p>
                              2D:
                              {discountPrize.showDisc2dPrize123
                                ? discountPrize.showDisc2dPrize123
                                : 0}
                              %
                            </p>
                          ) : (
                            <p>2D:{discountPrize.showDisc2d}%</p>
                          )
                        ) : (
                          <p>
                            4D:{discountPrize.showDisc4d}%,3D:
                            {discountPrize.showDisc3d}%,2D:
                            {discountPrize.showDisc2d}%
                          </p>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {"Discount:"}
                    {discountPrize.showDisc}%{" "}
                    {validPaths.includes(window.location.pathname) && (
                      <span>| kei:</span>
                    )}
                    <span>
                      {window.location.pathname === "/game/Fifty_Fifty"
                        ? discountPrize?.kei_as_kecil
                          ? `${discountPrize.kei_as_kecil}%`
                          : ""
                        : window.location.pathname === "/game/Fifty_Fifty_2D"
                          ? discountPrize?.kei_kecil
                            ? `${discountPrize.kei_kecil}%`
                            : ""
                          : window.location.pathname === "/game/Tengah_Dasar"
                            ? discountPrize?.gametype === "tengahtepi"
                              ? discountPrize.keitengah
                                ? `${discountPrize.keitengah}%`
                                : ""
                              : discountPrize.gametype === "dasar"
                                ? discountPrize.keibesar
                                  ? `${discountPrize.keibesar}%`
                                  : ""
                                : ""
                            : window.location.pathname === "/game/Silang_Kembang"
                              ? discountPrize?.gametype === "silanghomo"
                                ? discountPrize.kei_silang_depan
                                  ? `${discountPrize.kei_silang_depan}%`
                                  : ""
                                : discountPrize.gametype === "kembangkempis"
                                  ? discountPrize.kei_kembang_depan
                                    ? `${discountPrize.kei_kembang_depan}%`
                                    : ""
                                  : ""
                              : ""}
                    </span>
                  </>
                )}
              </p>
            </th>
            <th
              className="total_pay link2"
              style={{
                width: device === "Desktop" ? "15%" : "30%",
                whiteSpace: "nowrap",
                textAlign: "right",
                paddingRight: 5,
              }}
            >
              {props.t("total")} {props.t("Bet")}:&nbsp;
              <span className="betdiskon_total_discount">
                {props.gameName === "colokBebas" || props.gameName === "kombinasi" || props.gameName === "fiftyFifty2D" || props.gameName === "colokNaga" || props.gameName === "tengahDasar" || props.gameName === "shio" || props.gameName === "kombinasi" || props.gameName === "kombinasiMobile" ? (
                  formatPricewithdecimal(props.bbPayAmount > 0 ? props.bbPayAmount : !isNaN(props.totalBetAmount) ? props.totalBetAmount : 0)
                ) : (
                  formatPricewithdecimal(props.bbPayAmount > 0 ? props.bbPayAmount : props.totalBetAmount.filter(amount => amount !== undefined).reduce((accumulator, currentValue) => accumulator + currentValue, 0))
                )}
              </span>
            </th>
          </tr>
        </thead>
      </table>
      {isInfoPopup && (
        <InformasiPopup response={respData} onClose={closeInformasiPopup} />
      )}
    </>
  );
};

export default withTranslation()(CommonBetHeader);
